import PatientEditAddressDialog from './PatientEditAddressDialog.view';

export default PatientEditAddressDialog;
